import styles from './company-dialog.module.scss';
import { Col, Row } from 'reactstrap';
import {  useGetRequestNewHook, useMakeRequestHook } from '../../requestUtils';
import { useContext, useState } from 'react';
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, Divider, GrayOutlinedButton, PrimaryButton, SecondaryButton, SnackBarContext, TextField } from '@frontend-workspace/react-shared-lib';
import { INewCompanyRequest } from '../../_models/new-company-request';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CompanyDialogProps {
  open: boolean,
  onClose: () => void,
  company: INewCompanyRequest
}
interface ContentProps {
  open: boolean,
  onClose: () => void,
  company: INewCompanyRequest,
  requestData: IRequestData
}
interface IRequestData {
  sellers: {
    name: string,
    email: string
  }[],
  state: "DoesNotExist" | "ExistsInWebkua"
}
export function CompanyDialog(props: CompanyDialogProps) {

  const { data, isLoading }: { data: IRequestData, isLoading: boolean } = useGetRequestNewHook(`orders/${props.company.id}/companyRequestData`, { sellers: [], state: "DoesNotExist" });
  return !isLoading ? <CompanyDialogContent
    company={props.company}
    open={props.open}
    onClose={props.onClose}
    requestData={data}
  /> : null;

}
function CompanyDialogContent(props: ContentProps) {
  const makeRequest = useMakeRequestHook();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const { t } = useTranslation();
  const [sellerEmail, setSellerEmail] = useState("");
  const handleOK = () => {
    const body = {
      orderId: props.company.id,
      sellerEmail: sellerEmail
    }
    makeRequest(`admin/action/acceptCompanyRequest`, 'PUT', body).then(result => {
      setSnackbarMessage({ content: t("companyDialog.companyIsCreated"), type: "info" });
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t("companyDialog.couldNotCreateCompany"), type: "error" }));
  };

  const handleReject = () => {
    const body = { orderId: props.company.id };
    makeRequest(`admin/action/rejectNewCompanyRequest`, 'DELETE', body).then(result => {
      setSnackbarMessage({ content: t("companyDialog.requestDenied"), type: "success" });
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t("companyDialog.couldNotDeclineRequest"), type: "error" }));
  };
  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t("standard.processRequest")}
      </DialogTitle>
      <DialogContent>
        <div className='mb-3'>
          <TextField
            value={props.company.firstName}
            fullWidth
            label={t("standard.adminFirstName")}
            name='firstName'
            disabled
          />
        </div>
        <div className='mb-3'>
          <TextField
            value={props.company.lastName}
            fullWidth
            label={t("standard.adminLastName")}
            name='lastName'
            disabled
          />
        </div>
        <div className='mb-3'>
          <TextField
            value={props.company.companyEmail}
            fullWidth
            label={t("standard.email")}
            name='companyEmail'
            disabled
          />
        </div>
        <div className='mb-3'>
          <TextField
            value={props.company.userAddedInfo}
            fullWidth
            label={t("companyRequest.userAddedInfo")}
            name='userAddedInfo'
            disabled
          />
        </div>
        <Row>
          <Col sm={6}>
            <div className='mb-3'>
              <TextField
                value={props.company.companyPhoneNumber}
                fullWidth
                type="tel"
                label={t("standard.phone")}
                name='companyPhoneNumber'
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <div className='mb-3'>
              <TextField
                value={props.company.orgNr}
                fullWidth
                label={t("standard.organisationNumber")}
                name='orgNr'
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <div className='mb-3'>
            <TextField
              value={t(`companyRequest.${props.requestData.state}`)}
              fullWidth
              label={t(`companyRequest.status`)}
              name='status'
              disabled
            />
          </div>
        </Row>
        <Row>
          <Autocomplete
            value={sellerEmail}
            onChange={(e, newValue) => setSellerEmail(newValue.email)}
            options={props.requestData.sellers}
            getOptionLabel={(option: any) => option}
            renderOption={(props: any, option: { name: string, email: string }) => {
              return (
                <li {...props} key={option.email}>
                  {option.name}
                </li>
              );
            }}
            renderInput={(params: any) => <TextField {...params} label="Kundekontakt" fullWidth />}
          />
        </Row>
      </DialogContent>
      <DialogActions>
        <div className="d-flex flex-row flex-wrap">
          <div className='mb-3 mb-sm-0 me-3 me-sm-0'>
            <SecondaryButton
              variant='outlined'
              size='large'
              onClick={handleReject}
              className='minButtonWidth'>
              {t("standard.decline")}
            </SecondaryButton>
          </div>
          <Divider orientation="vertical" variant="middle" flexItem className="mx-4 d-none d-sm-block" />
          <div className='mb-3 mb-sm-0 me-3'>
            <PrimaryButton
              variant="contained"
              size='large'
              onClick={handleOK}
              disabled={!sellerEmail}
              className='minButtonWidth'>
              OK
            </PrimaryButton>
          </div>
          <div className='mb-3 mb-sm-0'>
            <GrayOutlinedButton
              variant="outlined"
              size='large'
              onClick={props.onClose}
              className='minButtonWidth'>
              {t("standard.cancel")}
            </GrayOutlinedButton>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default CompanyDialog;